<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container" >
      <div class="container-fluid" v-if="user.permission == 'admin'">
        <div class="row">
          <div class="col-3">
            <smallBar :user="user"></smallBar>
          </div>
          <div class="col-9">
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div class="pull-left">
                  <h3>目前方案</h3>
                </div>
              </div>
              <div class="widget-container">
              	<p v-if="contract == ''">
              		目前沒有選擇任何方案
              	</p>
              	<div v-else>
              		<h4>已啟用：{{contract.name}} , ${{contract.price*(100-company.discount)/100}} /每月每人 
              			<span v-if="company.discount != 0">(VIP折扣：{{company.discount}}%)</span>
              		</h4>
            			<h4>
              			<span v-if="contract.start_at != ''">{{contract.start_at}} ~ {{contract.end_at}}</span>
              		</h4>
              		<h4>
              			目前團隊人數：{{company.employees.length}}人
              		</h4>
              	</div>
              </div>
            </div>
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div class="pull-left">
                  <h3>信用卡綁定</h3>
                </div>
              </div>
              <div class="widget-container">
                <div class="widget-content" v-if="cards == ''">
                  <p>您尚未綁定有效的信用卡，請先綁定一張有效的信用卡，未來在做業務人數管理、以及方案變更、付費、都會非常方便喲！</p>
                  <p>我們不會儲存您的信用卡號，而是儲存銀行所發行的信用卡金鑰，而且此金鑰僅能使用在Flowneat網站，儲存非常安全，敬請放心</p>
                  <button @click="updateCardModal=true" class="btn btn-success" style="margin-top:0px;"><i class="fa fa-plus"></i> 前往綁定</button>
                </div>
                <div class="widget-content" v-else>
                  <div v-for="card in cards">
                    <h3><i v-bind:class="getCardIcon(card)"  style="margin-right:6px;"></i> {{card.number}}</h3>
                    <span class="btn btn-success btn-sm" v-if="card.status == 'used'">正常</span>
                  	<span class="btn btn-danger btn-sm" v-else>無法正常扣款</span>

                  	<span class="ml-2">綁定日期：{{card.created_at}}</span>

                    <small class="pull-right" style="margin-top:4px"><a class="row-edit" @click="removeCreditCardModal=true;removing_card=card"><i class="fas fa-trash"></i></a></small>
                    <small class="pull-right" style="margin-top:4px"><a class="row-edit" @click="changeCreditCardModal=true"><i class="fas fa-exchange-alt"></i></a></small> 
                    
                  </div>
                </div>
              </div>
            </div>
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div class="pull-left">
                  <h3>方案選擇：<span v-if="company.discount!= 0">(VIP折扣：{{company.discount}}%)</span></h3>
                </div>
              </div>
              <div class="widget-container">
              	<div class="row" v-for="plan in plans">
              		<div class="col-md-12">
                		<div class="card pb-3">
										  <div class="card-body p-3">
										  	<div class="row">
										  		<div class="col-md-6">
										  			<h3 class="card-title mb-5">{{plan.name}}</h3>
												    <p class="card-text"><i class="fa fa-check text-success"></i> 交易管理</p>
												    <p class="card-text"><i class="fa fa-check text-success"></i> 線上出報價單</p>
												    <p class="card-text"><i class="fa fa-check text-success"></i> 客戶管理</p>
												    <p class="card-text"><i class="fa fa-check text-success"></i> 服務管理</p>
												    <p class="card-text"><i class="fa fa-check text-success"></i> 專案管理</p>
												    <p class="card-text"><i class="fa fa-check text-success"></i> 專案收支管理</p>
										  		</div>
										  		<div class="col-md-6">
										  			<h4 v-if="company.discount!= 0">${{plan.price}}元/每人每月</h4>
										  			<h4 v-else>${{plan.price}}元/每人每月，折扣後{{plan.price*(100-company.discount)/100}}</h4>
										    		<p>按月扣款{{plan.price}}元，沒有合約長度限制，隨時可以決定取消或啟用，也可以開啟自動續約</p>
										    		<button v-if="contract.length == 0" @click="showMonthPlanModal=true;choose_plan = plan" class="btn btn-default">啟用月方案</button>
										    		<div v-else>
										    			<button v-if="contract.end_at == null" class="btn btn-success active">已啟用</button>
										    			<button v-else class="btn btn-default ">你尚有年約未到期，無法變更</button>
										    		</div>
										    		<hr>
										    		<h4>${{plan.year_price}}元/每人每月 省20%!</h4>
										    		<p>一次合約一年，按月扣款 {{plan.year_price}}元，合約到期之前不能改變方案，屬於划算的團隊方案</p>
										    		<button v-if="contract.length == 0" @click="showYearPlanModal=true;choose_plan = plan" class="btn btn-default">啟用年方案</button>
										    		<div v-else>
										    			<button v-if="contract.end_at != null" class="btn btn-success active">已啟用</button>
										    			<button v-else @click="showYearPlanModal=true" class="btn btn-default">升級為年方案</button>
										    		</div>
										  		</div>
										  	</div>
										  </div>
										</div>
									</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    <!--Page Container End Here-->
    <!-- modal template start-->
    <div v-if="updateCardModal" @keyup.esc="updateCardModal=false">
      <div class="modal-mask" @click="updateCardModal = false">
        <div class="modal-wrapper">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center" style="display:block">
              <div name="header">
                <h3>信用卡驗證與綁定</h3>
              </div>
            </div>
            <div class="modal-body">
              <p>您將被導向到<img width="100" src="../../assets/img/spgateway_logo.jpg">金流中心，進行信用卡刷卡驗證。</p>
              <p>您將被要求支付10元，但刷卡驗證成功後，您的10元將會退回，不會扣款。</p>
              <p>此動作尚不會產生任何費用，請安心綁定</p>
              <form style="display:none;" id="spgetway_form" method="post" v-bind:action='spgetway_url'>
                <input v-for="(item, key, index) in spgvalue" v-bind:name='key' v-bind:value='item'>
              </form>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-info" @click="goSpgetway()" v-if="goGateWay==false">
                  <i class="fa fa-lock"></i> 前往智付通驗證信用卡
                </button>
                <button class="btn btn-info disabled" v-if="goGateWay">
                  <i class="fas fa-spinner"></i> 智付通轉向中...
                </button>
                <button class="btn btn-default" @click="updateCardModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="removeCreditCardModal" @keyup.esc="removeCreditCardModal = false">
      <div class="modal-mask" @click="removeCreditCardModal = false">
        <div class="modal-wrapper">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center" style="display:block">
              <div name="header">
                <h3>移除綁定的信用卡</h3>
              </div>
            </div>
            <div class="modal-body">
              <h3>{{removing_card.number}}</h3>
              <p>移除此信用卡後，將不會再對此信用卡進行扣款。</p>
              <p>移除後，若使用權限到期，進行續約需重新綁定信用卡。</p>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-danger" @click="removeCreditCard(removing_card)">
                  <i class="fas fa-trash"></i> 確定移除
                </button>
                <button class="btn btn-default" @click="removeCreditCardModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="changeCreditCardModal" @keyup.esc="changeCreditCardModal = false">
      <div class="modal-mask" @click="changeCreditCardModal = false">
        <div class="modal-wrapper">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center" style="display:block">
              <div name="header">
                <h3>更換綁定的信用卡</h3>
              </div>
            </div>
            <div class="modal-body">
              <h3>{{removing_card.number}}</h3>
              <p>重新綁定新的信用卡後，舊的卡片將會被直接取代</p>
              <form style="display:none;" id="spgetway_form" method="post" v-bind:action='spgetway_url'>
                <input v-for="(item, key, index) in spgvalue" v-bind:name='key' v-bind:value='item'>
              </form>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-info" @click="goSpgetway()" v-if="goGateWay==false">
                  <i class="fa fa-lock"></i> 前往智付通驗證信用卡
                </button>
                <button class="btn btn-info disabled" v-if="goGateWay">
                  <i class="fas fa-spinner"></i> 智付通轉向中...
                </button>
                <button class="btn btn-default" @click="changeCreditCardModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="showMonthPlanModal" @keyup.esc="showMonthPlanModal = false">
      <div class="modal-mask" @click="showMonthPlanModal = false">
        <div class="modal-wrapper">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center" style="display:block">
              <div name="header">
                <h3>商務月方案</h3>
              </div>
            </div>
            <div class="modal-body">
              <h4>月方案是一個彈性的方案，每月25號將會自動從您綁定的信用卡扣款，您也可以隨時取消此方案，以下是月方案的注意事項：</h4>
              <ul class="text-left text-primary">
              	<li>每月25號自動扣款，並且延長下個月的使用期限, Ex: 2020/8/25號將會扣款9月份的金額，同時您的使用天數會自動延長到9月底</li>
              	<li v-if="sumOfMoney(month_user_bill)!= 0">啟用月方案的同時，將會依照比例，收取您今天到本月底的費用，如果您還有免費的使用天數未到期，則會從使用天數之後開始計算</li>
              </ul>
              <table class="table table-bordered" v-if="sumOfMoney(month_user_bill)!= 0">
          			<tr>
          				<th>用戶</th>
          				<th>到期日</th>
          				<th>到本月底天數</th>
          				<th>本月費用</th>
          			</tr>
          			<tr v-for="user in month_user_bill">
          				<td>{{user.name}}</td>
          				<td>{{user.start_at}}</td>
          				<td>{{user.days}}</td>
          				<td>${{user.price.toLocaleString()}}元</td>
          			</tr>
          		</table>
          		<H4 class="text-right">總金額：${{sumOfMoney(month_user_bill).toLocaleString()}}元</H4>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-info" @click="choosePlan(choose_plan,'month');showMonthPlanModal=false" v-if="goGateWay==false">
                  <i class="fa fa-check"></i> 確定啟用
                </button>
                <button class="btn btn-default" @click="showMonthPlanModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <div v-if="showYearPlanModal" @keyup.esc="showYearPlanModal = false">
      <div class="modal-mask" @click="showYearPlanModal = false">
        <div class="modal-wrapper">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center" style="display:block">
              <div name="header">
                <h3>商務年方案</h3>
              </div>
            </div>
            <div class="modal-body">
              <h4>年方案是一個划算的方案，啟用後將會綁定一年合約，節省20%費用！</h4>
              <ul class="text-left text-primary">
              	<li>每月25號自動扣款，並且延長下個月的使用期限, Ex: 2020/8/25號將會扣款9月份的金額，同時您的使用天數會自動延長到9月底</li>
              	<li>年約進行期間無法取消方案，也無法轉成月方案</li>
              	<li>年約到期之後會自動轉換成為月方案，若需要年方案需要重新啟用</li>
              	<li>年約進行期間如果刷卡失敗，可以重新綁定付款信用卡，或與我們聯繫協助您解決付款問題</li>
              	<li v-if="sumOfMoney(year_user_bill)!= 0">啟用月方案的同時，將會依照比例，收取您今天到本月底的費用，如果您還有免費的使用天數未到期，則會從使用天數之後開始計算</li>
              </ul>
              <table class="table table-bordered" v-if="sumOfMoney(year_user_bill)!= 0">
          			<tr>
          				<th>用戶</th>
          				<th>到期日</th>
          				<th>到本月底天數</th>
          				<th>本月費用</th>
          			</tr>
          			<tr v-for="user in year_user_bill">
          				<td>{{user.name}}</td>
          				<td>{{user.start_at}}</td>
          				<td>{{user.days}}</td>
          				<td>${{user.price.toLocaleString()}}元</td>
          			</tr>
          		</table>
          		<H4 class="text-right">總金額：${{sumOfMoney(year_user_bill).toLocaleString()}}元</H4>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-info" @click="choosePlan(choose_plan,'year');showYearPlanModal=false" v-if="goGateWay==false">
                  <i class="fa fa-check"></i> 確定啟用
                </button>
                <button class="btn btn-default" @click="showYearPlanModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import vueUrlParameters from 'vue-url-parameters';
import smallBar from './SmallBar.vue';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import Dropzone from 'vue2-dropzone'

export default {
  name: 'bill',
  mixins: [vueUrlParameters],
  components: {
    Simplert,Dropzone,smallBar
  },
  data() {
    return {
      removing_card:'',
      choose_plan:{},
      searchParams: {},
      spgetway_url: '',
      spgvalue: {},
      invoce_info: {},
      goGateWay: false,
      updateCardModal: false,
      removeCreditCardModal: false,
      changeCreditCardModal: false,
      showMonthPlanModal: false,
      showYearPlanModal: false,
      month_user_bill: [],
      year_user_bill: [],
      cards: '',
      company: '',
      contract: '',
      email: '',
      permission: '',
      refs: this.$refs,
      auth_token: '',
      plans: '',
    }
  },
  created() {
  	this.getPlans();
    this.getCompany();
    this.getCard();
  },
  props: ['toggle_aside','user'],
  mounted() {
    this.checkStatus();
  },
  methods: {
    goSpgetway(){
      var vm = this;
      vm.goGateWay = true;
      this.axios.post('orders/credit_card_binding').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.spgetway_url = response['data']['data']['url']
            vm.spgvalue = response['data']['data']['order'];
            setTimeout(function(){ 
              $('#spgetway_form').submit(); 

            }, 2000);
            ;
          } else {
            console.log('Error')
            vm.goGateWay = false;
          }
        }).catch(function(error) {
        console.log('error:', error)
        vm.goGateWay = false;
      });
    },
    getCompany() {
      // defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('settings/get_company').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.company = response['data']['data']['company']
          } else {
            console.log('Error')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    checkStatus(){
      var vm = this
      this.searchParams = this.getFiltersFromUrl(this.searchParams);
      if(this.searchParams.s == "success"){
        var obj = {
          isShown: true,
          title: '信用卡綁定成功',
          type: 'success',
          hideAllButton: true
        }
        vm.$refs.simplert.openSimplert(obj);
      }else{
        if(this.searchParams.s == "failed"){
          var obj = {
            isShown: true,
            title: '信用卡綁定失敗、請重新嘗試',
            type: 'error',
            hideAllButton: true
          }
          vm.$refs.simplert.openSimplert(obj);
        }
      }
    },
    getCard() {
      // defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('users/get_card').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.cards = response['data']['data']['cards']
            vm.contract = response['data']['data']['contract']
          } else {
            console.log('Error card')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    getCardIcon(card) {
      return {
        'fab fa-cc-visa': card.card_type == "visa"
      }
    },
    removeCreditCard(card){
      // defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.removeCreditCardModal=false;
      this.axios.post('users/remove_card', {
        card_token: card.card_token
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          var obj = {
            isShown: true,
            title: '移除成功',
            message: '你已成功移除這張信用卡，未來若有需要可在綁定',
            type: 'success',
            customCloseBtnText: '關閉'
          }
          vm.getCard();
          vm.refs.simplert.openSimplert(obj);
          vm.UpdateSalesTargetModal = false
        } else if (response['data']['status'] == 'fail') {
          var obj = {
            isShown: true,
            title: '更新業績失敗',
            message: '更新失敗',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
          vm.UpdateSalesTargetModal = false
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    getPlans(){
    	// defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('plans').then(
        function(response) {
          if (response.status == 200 && response['data']['status'] == "success") {
            vm.plans = response['data']['data']['plans']
            vm.month_user_bill = response['data']['data']['month_user_bill']
            vm.year_user_bill = response['data']['data']['year_user_bill']
          } else {
            vm.$toastr.w(
				      "方案資料抓取失敗，請重新整理或稍後再試"
				    );
          }
        }).catch(function(error) {
        vm.$toastr.w(
		      "方案資料抓取失敗，請重新整理或稍後再試"
		    );
      });
    },
    choosePlan(plan,plan_type){
      const vm = this;

      this.axios.post('plans', {
        plan: plan,
        type: plan_type,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == "success") {
        	vm.contract = response['data']['data']['plans']
          // clear input value
          if(vm.cards.length == 0){
		      	vm.updateCardModal = true
		      	vm.$toastr.s('方案選擇成功，但您尚未綁定信用卡，請進行綁定')
		      }else{
		      	vm.$toastr.s('方案啟用成功')
		      }
        } else {
          vm.$toastr.w(
			      response["data"]["msg"]
			    );
        }
      })
      .catch(function(error) {
        vm.$toastr.w(
		      "方案選擇失敗，請重新整理或稍後再試"
		    );
      });

    },
    sumOfMoney(users){
    	var result = 0;
    	$.each(users,function(i,e){
    		result+=e.price
    	})
    	return result
    }
  },
}
</script>


// WEBPACK FOOTER //
// CreditCardBinding.vue?b41295ea